import React, {useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import UserInfoCard from "./UserInfoCard";
import {Button} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import { useNavigate } from "react-router-dom";
import {logout} from "../../../api/AuthenticationEndpoints";
import {
    AUTH_PAGE_PATH,
    COMMUNICATOR_PAGE_PATH,
    EVENT_UPDATE_PAGE_PATH,
    SHIPMENT_TRACKING_PAGE_PATH,
    TERMS_AND_CONDITIONS_PAGE_PATH
} from '../../navigation/Navigator';
import ListItemLink from '../ListItemLink';
import {AuthorizedContext} from "../../../context/AuthorizedContext";
import {DESKTOP_LOGIN_LINKS} from "../../../constants/Links";
import {getDomain} from "../../../api/BackendRestClient";
import {SHIPMENT_PERMISSIONS} from "../../../constants/ShipmentPermissionsConstants";


export const DRAWER_WIDTH = 260;


const useStyles = makeStyles(() => ({
    drawerPaper: {
        width: DRAWER_WIDTH,
    },
    list: {
        "& img": {
            height: 35
        }
    }
}));

interface NavigationSidebarProps {
    open: boolean
    setOpen: (open: boolean) => void;
}


export const NavigationSidebar: React.FC<NavigationSidebarProps> = ({open, setOpen}) => {
    const {t} = useTranslation();
    const {authenticate, hasPermission} = useContext(AuthorizedContext);
    const navigate = useNavigate();

    const classes = useStyles();


    const executeLogout = () => {
        logout().then(() => {
            authenticate();
            navigate(AUTH_PAGE_PATH)
        })
    };

    return (<Drawer
            anchor="right"
            open={open}
            onClose={() => setOpen(false)}
            classes={{
                paper: classes.drawerPaper,
            }}
        >

            <UserInfoCard/>
            <List className={classes.list}>

                <ListItemLink href={SHIPMENT_TRACKING_PAGE_PATH}>
                    <ListItemIcon><img src={"/assets/icons/location_pin_blue.png"}
                                       alt={"shipment-tracking"}/></ListItemIcon>
                    <ListItemText primary={t("menu.shipment-tracking")}/>
                </ListItemLink>


                <ListItemLink href={COMMUNICATOR_PAGE_PATH}>
                    <ListItemIcon><img src={"/assets/icons/user_message_blue.png"}
                                       alt={"communicator"}/></ListItemIcon>
                    <ListItemText primary={t("menu.communicator")}/>
                </ListItemLink>

                {hasPermission(SHIPMENT_PERMISSIONS.MILESTONE_LIST) &&
                <ListItemLink href={EVENT_UPDATE_PAGE_PATH}>
                    <ListItemIcon><img src={"/assets/icons/clock_forward_blue.png"}
                                       alt={"event-update"}/></ListItemIcon>
                    <ListItemText primary={t("menu.event-update")}/>
                </ListItemLink>
                }
            </List>
            <Divider/>
            <List>
                <ListItem>
                    <Button href={TERMS_AND_CONDITIONS_PAGE_PATH} fullWidth={true}
                            variant="contained" size="small"
                            color="primary">{t("buttons.terms-and-conditions")}</Button>
                </ListItem>
                <ListItem>
                    <Button href={DESKTOP_LOGIN_LINKS[getDomain()]} fullWidth={true} variant="contained" size="small"
                            color="primary">{t("buttons.switch-to-desktop")}</Button>
                </ListItem>

            </List>
            <Divider/>
            <List>
                <ListItem>
                    <Button onClick={executeLogout} fullWidth={true} variant="contained"
                            size="small">{t("buttons.logout")}</Button>
                </ListItem>
            </List>
        </Drawer>
    );


};

export default NavigationSidebar;